/** FEAT-066 (MVP-18.1) — guest discovery blur gate tile limit. */
export const GUEST_VISIBLE_TILE_LIMIT = 10;
